import styled from 'styled-components';

const Container = styled.div`
  max-width: 72rem;

  padding-right: 1rem;
  padding-left: 1rem;
  margin-right: auto;
  margin-left: auto;
`;

export default Container;
